import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-border-t tw-p-4" }
const _hoisted_2 = { class: "tw-mt-4 tw-flex tw-justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioSelect = _resolveComponent("StudioSelect")!
  const _component_StudioInput = _resolveComponent("StudioInput")!
  const _component_StudioButton = _resolveComponent("StudioButton")!
  const _component_ModuleWrapper = _resolveComponent("ModuleWrapper")!

  return (_openBlock(), _createBlock(_component_ModuleWrapper, { moduleId: _ctx.moduleId }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_StudioSelect, {
          id: "domain-type-select",
          label: "Domain Type",
          class: "tw-mb-4",
          options: [{ value: 'Email', label: 'Email' }],
          value: _ctx.domainType,
          onChange: _cache[0] || (_cache[0] = e => (_ctx.domainType = e.target.value))
        }, null, 8, ["value"]),
        (_ctx.domainType === 'Email')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_StudioInput, {
                id: "email-input",
                label: "Email Address (for sending registration/reminder notifications)",
                placeholder: "yourname@example.com",
                class: "tw-mb-2",
                modelValue: _ctx.emailInputValue,
                inlineError: _ctx.emailInvalidError,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = value => _ctx.handleEmailInput(value))
              }, null, 8, ["modelValue", "inlineError"]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_StudioButton, {
                  disabled: _ctx.isCreateEmailSignatureLoading || !!_ctx.emailInvalidError,
                  trackingId: "create-email-signature-button",
                  onClick: _ctx.onContinueClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isCreateEmailSignatureLoading ? 'Loading...' : 'Continue'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["moduleId"]))
}